import { useTranslations } from '@vocab/react';
import { Strong, Text } from 'braid-design-system';

import translations from 'src/App/App.vocab';

import { useSearchUsers } from '../SearchUsers/SearchUsers';

interface UsersCountProps {
  isSearchState: boolean;
  searchTerm: string;
}

export const UsersCount = ({ isSearchState, searchTerm }: UsersCountProps) => {
  const { t } = useTranslations(translations);
  const { searchResults } = useSearchUsers();
  const count = searchResults?.length;

  const teamMemberPlural = t('Team members matching', {
    plural: count === 1 ? t('Member') : t('Members'),
  });
  const teamMemberDescriptor = isSearchState
    ? teamMemberPlural
    : t('Team member count');

  return (
    <Text>
      <Strong>{count}</Strong> {teamMemberDescriptor}{' '}
      {searchTerm.length ? `"${searchTerm}"` : null}
    </Text>
  );
};
